//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Privs',
  data: function data() {
    return {
      privs: [{
        title: '尊贵身份',
        pic: '//puui.qpic.cn/vupload/0/20190429_1556543395530_4qqe9y1aywn.png/0',
        tabIndex: 7
      }, {
        title: '广告特权',
        pic: '//i.gtimg.cn/qqlive/images/20160612/i1465697986_1.jpg',
        tabIndex: 5
      }, {
        title: '院线新片',
        pic: '//i.gtimg.cn/qqlive/images/20160612/i1465697932_1.jpg',
        tabIndex: 0
      }, {
        title: '独家美剧',
        pic: '//i.gtimg.cn/qqlive/images/20160612/i1465697943_1.jpg',
        tabIndex: 1
      }]
    };
  }
};